import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as InstitutionActions from '../actions/Institution';
import InstitutionDetail from '../components/InstitutionDetail';

function mapStateToProps(state) {
  return {
    institution: state.institution,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    institutionActions: bindActionCreators(InstitutionActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InstitutionDetail);



// WEBPACK FOOTER //
// ./src/containers/InstitutionDetail.js